module.exports = __webpack_public_path__ + "static/media/poster.d80d1bf6.webp";